module.exports = __webpack_public_path__ + "img/EL.f89673cf.svg";